import { api } from '@akinon/next/data/client/api';

export const walletApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getWallet: builder.query({
      query: ({ customer_id, user_email }) => ({
        url: `/api/extension/api/member_type/`,
        method: 'POST',
        body: {
          customer_id,
          user_email
        }
      })
    })
  })
});

export const { useGetWalletQuery } = walletApi;
